import React, { FC, useEffect, useMemo, useState } from 'react';


import { SliderControlsProps } from './types';
import { PagingControls } from '../PagingControls';


export const SliderControls: FC<SliderControlsProps> = ({
    glider, slidesCount, elementsViewCount = 1, ...props
}) => {
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        glider.on('move', () => setCurrentPage(Math.floor(glider.index / elementsViewCount + 1)));
        return () => {
            glider.on('move', () => null);
        };
    }, [elementsViewCount, glider]);

    const pageCount = useMemo(() => Math.ceil(slidesCount / elementsViewCount),
        [slidesCount, elementsViewCount]);
    return (
        <PagingControls
            onPrevious={() => glider.go('|<')}
            onNext={() => glider.go('|>')}
            onPageNumber={number => glider.go(`=${(number - 1) * elementsViewCount}`)}
            currentPage={currentPage}
            pageCount={pageCount}
            {...props}
        />
    );
};
